function getRoomLabel(t, index) {
  return `${t("room")} #${index + 1}`;
}

const hotelValidators = {
  // Step 1 → Title
  1: ({ step1 }, t) => {
    if (!step1.name?.trim()) return t("please_fill_hotel_name");
    return null;
  },

  // Step 2 → Location
  2: ({ step1 }, t) => {
    if (!step1.country_id) return t("please_select_country");
    if (!step1.city_id) return t("please_select_city");
    if (!step1.address?.trim()) return t("please_fill_address");
    if (!step1.phone?.trim()) return t("please_fill_phone");
    
    if (
      (step1.latitude && !step1.longitude) ||
      (!step1.latitude && step1.longitude)
    ) {
      return t("please_fill_complete_coordinates");
    }
    return null;
  },

  // Step 3 → Description
  3: ({ step1 }, t) => {
    if (!step1.short_summary?.trim()) return t("please_fill_summary");
    if (step1.short_summary.trim().length < 32) return t("summary_too_short");
    if (!step1.detailed_description?.trim())
      return t("please_fill_description");
    if (step1.detailed_description.trim().length < 60)
      return t("description_too_short");
    return null;
  },
  // Step 4 → Informations
  4: ({ step1 }, t) => {
    if (
      step1.number_of_restaurant < 0 ||
      step1.number_of_swimmingpool < 0 ||
      step1.number_of_floor < 1 ||
      step1.number_of_rooms < 10
    )
      return t("please_check_general_numbers");
    return null;
  },
  // Step 5 → General Info
  5: ({ step1 }, t) => {
    if (!step1.construction_year) return t("please_select_construction_year");
    if (!step1.last_renovation_year) return t("please_select_renovation_year");
    if (!step1.meal_age_autorizate)
      return t("please_fill_meal_age_authorization");
    if (!step1.checkin_time) return t("please_fill_checkin_time");
    if (!step1.checkout_time) return t("please_fill_checkout_time");
    // if (step1.checkin_time >= step1.checkout_time)
    //   return t("checkout_must_be_after_checkin");
    if (!step1.pricing_type) return t("please_select_pricing_type");
    return null;
  },



  // Step 6 → Reception Services
  6: ({ step2 }, t) => {
    if (step2.is_has_reception) {
      const r = step2.reception;
      if (r.days?.length === 0) return t("please_select_reception_days");
      if (!r.start_time || !r.end_time) return t("please_fill_reception_hours");
      if (r.start_time >= r.end_time) {
        return t("day_end_must_be_after_start");
      }
    }

    if (step2.is_has_reception_virtual && !step2.welcomProcedure.length)
      return t("please_add_welcome_procedure");

    if (step2.is_will_welcome_travelers && step2.welcomProcedure.length === 0)
    return t("The welcome procedure field is required when is will welcome travelers is true.");

    if (step2.is_early_arrival_available) {
      const e = step2.early_arrival;
      if (!e.start_time || !e.end_time)
        return t("please_fill_early_arrival_times");
      if (e.start_time >= e.end_time) {
        return t("early_arrival_day_end_must_be_after_start");
      }
      if (e.price===null || e.price < 0) return t("please_fill_early_arrival_price");
    }

    if (step2.is_late_arrival_available) {
      const l = step2.late_arrival;
      if (!l.start_time || !l.end_time)
        return t("please_fill_late_arrival_times");
      if (l.start_time >= l.end_time) {
        return t("late_arrival_day_end_must_be_after_start");
      }
      if (l.price===null || l.price < 0) return t("please_fill_late_arrival_price");
    }

    if (!step2.min_check_in_age) return t("please_fill_min_checkin_age");
    if (
      step2.min_check_in_age &&
      (isNaN(step2.min_check_in_age) || step2.min_check_in_age < 0)
    )
      return t("invalid_min_checkin_age");

    return null;
  },

  // Step 7 → Equipments
  7: ({ step2 }, t) => {
    const eq = [
      ["is_has_internet_connection", "internetService"],
      ["is_parking_available", "parkingService"],
      ["is_swimming_pool_available", "swimmingPoolService"],
      ["is_accessibility_arrangement", "accessibilityArrangement"],
      ["is_general_services_available", "generalService"],
      ["is_room_amenities", "roomAmenities"],
      ["is_sports_attractions", "sportAttractionService"],
      ["is_wellness_services", "wellnessService"],
      ["is_business_services", "businessService"],
      ["is_family_romantic_services", "familyRomantiqueService"],
      ["is_nature_environment_services", "natureEnvironment"],
    ];

    for (const [flag, list] of eq) {
      if (step2[flag]) {
        const data = step2[list];

        // must exist and be non-empty
        if (!data || data.length === 0) return t(`please_select_${list}`);

        // if list items are objects (not plain IDs)
        if (Array.isArray(data) && typeof data[0] === "object") {
          for (const item of data) {
            // generic equipment-based validation
            if (
              "equipements" in item &&
              (!item.equipements || item.equipements.length === 0)
            ) {
              return t(`please_select_equipements_for_${list}`);
            }

            // if service has costs or times, ensure they exist
            if (
              "cost" in item &&
              (item.cost === null ||
                item.cost === undefined ||
                item.cost === "")
            ) {
              return t(`please_set_cost_for_${list}`);
            }

            if (
              ("start_time" in item || "end_time" in item) &&
              (!item.start_time || !item.end_time)
            ) {
              return t(`please_set_time_for_${list}`);
            }
          }
        }
      }
    }

    return null;
  },

  // Step 8 → Rooming
  8: ({ step3 }, t) => {
    if (!Array.isArray(step3.rooms) || !step3.rooms.length)
      return t("please_add_at_least_one_room");

    for (let i = 0; i < step3.rooms.length; i++) {
      const room = step3.rooms[i];
      const label = getRoomLabel(t, i);

      if (!room.room_type_id) return t("room_missing_type", { room: label });
      if (!room.room_option_id) return t("room_missing_option", { room: label });
      if (!room.bed_type_id) return t("room_missing_bed_type", { room: label });
      if (!room.total_rooms_of_this_type || room.total_rooms_of_this_type <= 0)
        return t("room_invalid_total_rooms", { room: label });
      if (!room.number_of_beds || room.number_of_beds <= 0)
        return t("room_invalid_bed_count", { room: label });
      if (room.min_adults <= 0)
        return t("room_invalid_min_adults", { room: label });
      if (room.max_adults < room.min_adults)
        return t("room_invalid_adults_range", { room: label });
      if (room.max_children < room.min_children)
        return t("room_invalid_children_range", { room: label });

      const pricing = room.pricing;
      if (!pricing.start_date || !pricing.end_date)
        return t("room_missing_pricing_dates", { room: label });
      if (!pricing.price || pricing.price <= 0)
        return t("room_invalid_price", { room: label });
       if (!pricing.mealId) return t("room_missing_meal_plan", { room: label });
    }

    return null;
  },

  // Step 9 → Review
  10: ({ step1 }, t) => {
    if (!step1.short_summary?.trim())
      return t("please_fill_summary_before_submit");
    if (!step1.detailed_description?.trim())
      return t("please_fill_description_before_submit");
    return null;
  },
};

export default hotelValidators;
